<template>
<div>
<div  class="d-block d-lg-none d-xl-none ">
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      
      
      background="#ababab"
      img-width="1024"
      img-height="180"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
    <!-- controls -->
      <!-- Text slides with image -->
      <b-carousel-slide  img-src="https://p.w3layouts.com/demos/june-2016/01-06-2016/big_store/web/images/co2.jpg">
      
      </b-carousel-slide>
      <b-carousel-slide  img-src="https://p.w3layouts.com/demos/june-2016/01-06-2016/big_store/web/images/co3.jpg" >
     
      </b-carousel-slide>


      <!-- Slide with blank fluid image to maintain slide aspect ratio -->
      
    </b-carousel>

   
  </div>
  
    <b-carousel
    class="d-none d-lg-flex d-xl-flex"
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      
      
      background="#ababab"
      
      style="text-shadow: 1px 1px 2px #333; height:500px; width:100%"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
    <!-- controls -->
      <!-- Text slides with image -->
      <b-carousel-slide  img-src="https://p.w3layouts.com/demos/june-2016/01-06-2016/big_store/web/images/co2.jpg">
      
      </b-carousel-slide>
       <b-carousel-slide  img-src="https://p.w3layouts.com/demos/june-2016/01-06-2016/big_store/web/images/co3.jpg" >
     
      </b-carousel-slide>

      


      <!-- Slide with blank fluid image to maintain slide aspect ratio -->
      
    </b-carousel>

   
  
   </div>
</template>

<script>
  export default {
    data() {
      return {
        slide: 0,
        sliding: null,
        hidelap:false
      }
    },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
</script>
<style scoped>
.img-fluid {
    max-width: 100%;
    height: 200px !important;
}
.carousel-caption {
    
    z-index: 2 !important;
}
</style>